module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-select', {
    key: _vm.selectKey,
    ref: "selectDom",
    attrs: {
      "placeholder": _vm.placeholder,
      "clearable": "",
      "filterable": _vm.filterable,
      "disabled": _vm.disabled
    },
    on: {
      "change": _vm.handleChange
    },
    nativeOn: {
      "!blur": function($event) {
        return _vm.blur($event)
      }
    },
    model: {
      value: (_vm.selectedValue),
      callback: function($$v) {
        _vm.selectedValue = $$v
      },
      expression: "selectedValue"
    }
  }, _vm._l((_vm.normalizedOptions), function(item) {
    return _c('el-option', {
      key: item.optionValue,
      attrs: {
        "label": item.Text,
        "value": item.optionValue
      }
    }, [_vm._v("\n        " + _vm._s(item.Text) + "\n    ")])
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-82509b7a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/picklist/src/main.vue
// module id = 1458
// module chunks = 116